import { render, staticRenderFns } from "./shelfDetail.vue?vue&type=template&id=1d2e6920&scoped=true&"
import script from "./shelfDetail.vue?vue&type=script&lang=js&"
export * from "./shelfDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e6920",
  null
  
)

export default component.exports